import { Routes } from '@angular/router';
import { ServiceMaintenanceComponent } from '../components/service-maintenance/service-maintenance.component';

/**
 * "We are in business" maintenance switch (Gate 2) — router half.
 *
 * Wrap an app's real route table at `provideRouter` time:
 *
 *   provideRouter(withMaintenanceMode(appRoutes, environment.maintenanceMode), ...)
 *
 * When `maintenanceMode` is true the real routes are discarded entirely and a
 * single catch-all route renders the shared `ServiceMaintenanceComponent`, so
 * EVERY path (including deep links and lazy children) shows the maintenance page
 * — no route can leak past it. When false/undefined the app's real routes are
 * returned unchanged, so the live app pays zero runtime cost.
 *
 * This is a build-time flag (sourced from `MAINTENANCE_MODE` via
 * generate-env.mjs), so flipping it requires re-running the app's deploy
 * workflow. The upgrade path to a no-rebuild toggle is to feed this helper a
 * value resolved at bootstrap from a runtime config fetch instead of the baked
 * `environment` constant — the helper's signature does not change.
 */
export function withMaintenanceMode(routes: Routes, maintenanceMode: boolean | undefined): Routes {
  if (!maintenanceMode) {
    return routes;
  }
  return [{ path: '**', component: ServiceMaintenanceComponent }];
}
